import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ConfigurationService} from 'src/app/core/config/configuration.service';
import {IAddress} from 'src/app/interfaces/general/profile-definitions/address.interface';

@Injectable({
    providedIn: 'root',
})
export class AddressesService {
    private readonly _addressesBaseUrl: string;

    constructor(
        private http: HttpClient,
        private config: ConfigurationService,
    ) {
        this._addressesBaseUrl = this.config.get('profileApiUrl') + '/addresses';
    }

    public getAll(): Observable<IAddress[]> {
        return this.http
            .get<IAddress[]>(this._addressesBaseUrl)
            .pipe(map((addresses) => addresses.map((a) => this.mapIdentifier(a))));
    }

    public getById(identifier: string): Observable<IAddress> {
        return this.http
            .get<IAddress>(`${this._addressesBaseUrl}/${identifier}`)
            .pipe(map((a) => this.mapIdentifier(a)));
    }

    public create(address: Partial<IAddress>): Observable<IAddress> {
        return this.http
            .post<IAddress>(this._addressesBaseUrl, address)
            .pipe(map((a) => this.mapIdentifier(a)));
    }

    public update(identifier: string, address: Partial<IAddress>): Observable<IAddress> {
        return this.http
            .put<IAddress>(`${this._addressesBaseUrl}/${identifier}`, address)
            .pipe(map((a) => this.mapIdentifier(a)));
    }

    public delete(identifier: string): Observable<void> {
        return this.http.delete<void>(`${this._addressesBaseUrl}/${identifier}`);
    }

    private mapIdentifier(address: IAddress): IAddress {
        const id = address['@id']?.split('/').pop();
        return {...address, identifier: id};
    }
}